window.BLISART = window.BLISART || {};

window.BLISART.PubSub = (function() {
  const events = {};

  function subscribe(event, callback) {
    if (!events[event]) events[event] = [];
    events[event].push(callback);
    return function unsubscribe() {
      events[event] = events[event].filter(cb => cb !== callback);
    };
  }

  function publish(event, data) {
    if (!events[event]) return;
    events[event].forEach(callback => callback(data));
  }

  return { subscribe, publish };
})();
